import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function KraaftComparisonSection() {
  return <section className="py-12 sm:py-16 bg-gray-50 border-t border-gray-200" data-id="element-156">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="text-center mb-10 sm:mb-12" data-id="element-158">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900" data-id="element-159">
            ¿Por qué no usar otra app?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-10" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 border border-red-100 shadow-sm" data-id="element-161">
            <div className="flex items-center gap-3 mb-4" data-id="element-162">
              <XCircle className="w-6 h-6 text-red-500" data-id="element-163" />
              <h3 className="text-lg font-bold text-gray-900" data-id="element-164">Otras apps</h3>
            </div>
            <p className="text-gray-600 leading-relaxed" data-id="element-165">
              Te piden que dejes WhatsApp. Que descargues algo nuevo. Que
              convenzas a tu equipo. Que capacites a los maestros.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-blue-600 rounded-2xl p-8 shadow-md" data-id="element-166">
            <div className="flex items-center gap-3 mb-4" data-id="element-167">
              <CheckCircle2 className="w-6 h-6 text-white" data-id="element-168" />
              <h3 className="text-lg font-bold text-white" data-id="element-169">Obra Digital</h3>
            </div>
            <p className="text-blue-50 leading-relaxed" data-id="element-170">
              Funciona con el WhatsApp que ya usas. Tu equipo no instala nada.
              No aprende nada. No cambia nada.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-171">
          <p className="inline-block px-6 py-3 bg-white border border-gray-200 rounded-full text-lg font-bold text-gray-900 shadow-sm" data-id="element-172">
            La mejor app es la que nadie tiene que aprender.
          </p>
        </motion.div>
      </div>
    </section>;
}